import axios from './http';
import { CancelTokenSource } from 'axios';
import { EntityStorageStatisticsDto, StorageInfoDto } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/storage`;

export const getStorageInfo = (source: CancelTokenSource): Promise<StorageInfoDto> => {
  return axios
      .get(`${apiUri}/account-info`, {cancelToken: source.token})
      .then(response => response.data);
};

export const getEntityStatistics = (entity: string,
                                    storageInfoUndefined: boolean,
                                    source: CancelTokenSource): Promise<EntityStorageStatisticsDto> => {
  return axios
      .get(`${apiUri}/${entity}/statistics`,
          {params: {storageInfoUndefined: storageInfoUndefined}, cancelToken: source.token})
      .then(response => response.data);
};

export const moveDataBaseResourcesToStorage = (entity: string, quantity: number, source: CancelTokenSource) => {
  return axios
      .post(`${apiUri}/${entity}/move-resources-to-storage`, null, {params: {quantity: quantity}, cancelToken: source.token})
      .then(response => response.data)
}
